'use client';

import type { ReactNode } from 'react';
import { Box } from '@mantine/core';

export function PublicPageShell({ children }: { children: ReactNode }) {
  return (
    <Box
      component="main"
      id="main-content"
      mih="100vh"
      style={{
        color: 'var(--text-primary)',
        background: 'var(--surface-base)',
      }}
    >
      {children}
    </Box>
  );
}
